module.exports = __webpack_public_path__ + "img/file-invoice-dollar.6fbec5ab.svg";